import { render, staticRenderFns } from "./ScoreBox.vue?vue&type=template&id=1019142e&scoped=true&"
import script from "./ScoreBox.vue?vue&type=script&lang=js&"
export * from "./ScoreBox.vue?vue&type=script&lang=js&"
import style0 from "./ScoreBox.vue?vue&type=style&index=0&id=1019142e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1019142e",
  null
  
)

export default component.exports